import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EnvironmentCreate } from '../../interfaces';
import { FsSkeletonModule } from '@firestitch/skeleton';
import { FormsModule } from '@angular/forms';
import { FsFormModule } from '@firestitch/form';
import { MatCardContent, MatCardActions } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-project',
    templateUrl: './project.component.html',
    styleUrls: ['./project.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FsSkeletonModule,
        FormsModule,
        FsFormModule,
        MatCardContent,
        MatFormField,
        MatLabel,
        MatInput,
        MatCardActions,
        MatButton,
    ]
})
export class ProjectComponent {

  @Input() public environmentCreate: EnvironmentCreate = null;

  @Output() public environmentCreateChange = new EventEmitter<EnvironmentCreate>();

  constructor() { }

  public save = () => {
    return of(this.environmentCreate)
      .pipe(
        tap((response) => this.environmentCreateChange.emit(response)),
      );
  };
}
